import React, { useEffect } from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import styles from '../../../styles'
import classNames from 'classnames'
import Icon from '../../../components/icon/Icon'
import { ModelCategory, ModelTheme } from '../../../types/faq/faq_model'
import ThemeCompo from './ThemeCompo'
import { Element, scroller } from 'react-scroll'
import { useMediaQuery } from 'react-responsive'
import iconsEnum from '../../../enums/iconsEnum'
import { useLocation } from 'react-router'
import { offSet } from '../faq_header/FaqHeaderSubmenu'

const useStyle = makeStyles((theme) => ({
		...styles(theme),
		divLargeScreen: {
			marginBottom: '84px'
		},
		divSmallScreen: {
			marginBottom: '54px'
		},
		divCategory: {
			display: 'flex',
			alignItems: 'center'
		},
		divLargeTitleCategory: {
			marginBottom: '34px'
		},
		divSmallTitleCategory: {
			marginBottom: '24px'
		},
		categoryName: {
			marginLeft: '5%'
		},
		icon: {
			fill: theme.palette.blue.main
		}
	}
))

interface AcceptingProps {
	expandDefault: boolean,
}

type CategoryProps = ModelCategory & AcceptingProps

const Category: React.FC<CategoryProps> = (
	{
		themes,
		name,
		icon,
		expandDefault
	}
) => {
	const classes = useStyle()
	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1025px)'
		}
	)

	const divTitleCategoryClass = classNames(
		isLargeScreen ? [classes.title2] : [classes.title3],
		isLargeScreen ? [classes.divLargeTitleCategory] : [classes.divSmallTitleCategory],
		classes.divCategory,
		classes.colorAccessibility
	)

	const divClass = classNames(
		isLargeScreen ? [classes.divLargeScreen] : [classes.divSmallScreen]
	)

	const location = useLocation()

	useEffect(
		() => {
			if (location.hash) {
				const hash = decodeURIComponent(location.hash).substr(1)
				scroller.scrollTo(hash, {
					duration: 1500,
					delay: 100,
					smooth: true,
					offset: offSet
				})
			}
		}, [location.hash]
	)

	return (
		<Element name={name}>
			<div className={divClass}>
				<div className={divTitleCategoryClass}>
					<Icon size={isLargeScreen ? 50 : 40} icon={icon ? iconsEnum[icon] : iconsEnum.Default}
					      className={classes.icon} />
					<span className={classes.categoryName}>
                        {name}
                    </span>
				</div>
				{
					themes.map(
						(theme: ModelTheme, key) => (
							theme.questions && theme.questions.length > 0 &&
							<ThemeCompo
								name={theme.name}
								questions={theme.questions}
								expandDefault={expandDefault}
							/>
						)
					)
				}
			</div>
		</Element>
	)
}

export default Category
